import { Environment } from '@campaign-portal/components-library';

export const environment: Environment = {

	production: true,
	version: '2.1.0',

	protocol: '',
	host: '',
	port: '',
	api: 'v1',
	localStorageKey: 'hlr',
	configURL: `./assets/config.json?v=${(new Date()).getTime()}`,

	exchangeFolder: '',

	title: 'MNP Configurator',
	subTitle: '',

	theme: 'blue',
	themeType: window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light',


	termsUrl: '',
	privacyUrl: '',
	supportEmail: '',

	showLink: true,
	allowRegistration: false,

	systemTZOffset: 0,
	localTime: false,

	languagesID: ['en', 'es', 'ru', 'cn'],

	releaseDate: '',

	is2FA: false
};
